import React from "react";
import { CardWrapper, CardAbove, CardHeader, CardTitle, Left, Right, Card, CardContent, CardFooter } from "../components/Card";

export default function TestPage() {
  return (
    <CardWrapper>
      <CardAbove>
        <Left>Left</Left>
        <Right>Right</Right>
      </CardAbove>
      <Card>
        <CardHeader>
          <CardTitle>Card Title</CardTitle>
          <Right>Right</Right>
        </CardHeader>
        <CardContent>
          Brisket chicken capicola mignon t strip meatball tenderloin belly turkey doner leberkas jowl.
        </CardContent>
        <CardFooter>
          <Left>Left</Left>
          <Right>Right</Right>
        </CardFooter>
      </Card>
    </CardWrapper>
  )
}
